import { render } from "./spinner-vrak.vue?vue&type=template&id=96d9c796"
import script from "./spinner-vrak.vue?vue&type=script&lang=js"
export * from "./spinner-vrak.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__